<p *ngIf="!loaded" class="picker-note">Pobieranie umów i kursów…</p>
<p *ngIf="loadFailed" class="picker-note">Nie udało się pobrać umów szkoły.</p>

<ng-container *ngIf="loaded && !loadFailed">
  <div *ngIf="hasAgreements; else noAgreements" class="agreement-picker">
    <label class="agreement-picker__field">
      <span>Kurs</span>
      <p-dropdown
        [options]="courseOptions"
        [(ngModel)]="courseGuid"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        placeholder="Wybierz kurs (opcjonalnie)"
        emptyMessage="Brak kursów dla tej kategorii"
        styleClass="w-full"
        appendTo="body"
        (onChange)="onCourseChange()"
      ></p-dropdown>
    </label>
    <label class="agreement-picker__field">
      <span>Umowa</span>
      <p-dropdown
        [options]="agreementOptions"
        [(ngModel)]="agreementGuid"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        placeholder="Wybierz umowę"
        emptyMessage="Brak umów dla tej kategorii"
        styleClass="w-full"
        appendTo="body"
        (onChange)="emit()"
      ></p-dropdown>
    </label>
  </div>
  <ng-template #noAgreements>
    <p class="picker-note">
      Szkoła nie ma jeszcze własnych umów. Przygotuj je w zakładce „Umowy i kursy” - na podstawie wzorców operatora.
    </p>
  </ng-template>
</ng-container>
